<div class="breadcrumb">
	<div class="row">
		<div class="col d-flex align-items-center">
      <ng-container *ngFor="let breadcrumb of breadcrumbList; let i = index">
        <a [routerLink]="[generateBreadcrumbLink(breadcrumb)]">{{breadcrumb.name}}</a>
        <i class="fal fa-angle-right" *ngIf="i < (breadcrumbList.length - 1)"></i>
      </ng-container>
		</div>
	</div>
</div>
<div class="header">
	<div class="d-flex flex-row bd-highlight mb-3 align-items-center">
		<div class="title-container d-flex align-items-center">
			<h1 class="mt-2">{{title}}</h1>
			<ng-container *ngIf="actionButton != null">
				<a class="ms-4 action-button" mat-stroked-button [href]="actionButton.url" mat-stroked-button>
					<i class="fal {{actionButton.icon}}"></i>
					{{actionButton.name}}
				</a>
				<div class="tooltip-wrapper" *ngIf="actionButton.tooltip">
					<i class="fal fa-question-circle" (click)="tooltip = !tooltip"></i>
					<div class="tooltip-content" *ngIf="tooltip">{{actionButton.tooltip}}</div>
				</div>
			</ng-container>
		</div>
		<div class="ms-auto d-flex" *ngIf="filterConfiguration">
			<div class="row">
				<div class="col col-auto">
					<div class="filter-timesheet">
						<app-side-filter
							#sideFilter
							(onChange)="onChangeSideFilter($event)"
							[filterConfiguration]="filterConfiguration"
						></app-side-filter>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>